import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteConfig } from '@/shared/lib';

type Props = {
  label: RouteConfig['label'];
};

export const AppSidebarLabel: FC<Props> = ({ label }) => {
  const { i18n } = useTranslation();

  return label instanceof Function ? label({ i18n: i18n }) : label;
};
